import { render } from "./documentTab.vue?vue&type=template&id=6d9c84c3"
import script from "./documentTab.vue?vue&type=script&lang=ts"
export * from "./documentTab.vue?vue&type=script&lang=ts"
script.render = render

export default script